import React, { useEffect, useState } from "react";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useTemplateContext } from "../../../context/TemplateContext";
import PdfTemplateEditor from "./PdfTemplateEditor";

const PdfTemplateViewer = ({ file }) => {
  const { templateData, setTemplateData } = useTemplateContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchTemplate = async () => {
    try {
      setIsLoading(true);
      const res = await axiosInstance.get(`/pdf_template/${file.id}`);
      setTemplateData(res.data);
    } catch (err) {
      setError("Failed to load PDF template.");
      handleApiError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) return <Loader />;
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!templateData) return null;

  return <PdfTemplateEditor file={file} templateData={templateData} setTemplateData={setTemplateData} />;
};

export default PdfTemplateViewer;
